module.exports = __webpack_public_path__ + "static/media/sc36.40.9233a77b.mp4";